import { App as AntdApp, ConfigProvider } from 'antd';
import type { Locale } from 'antd/lib/locale';
import enGB from 'antd/locale/en_GB';
import { useState } from 'react';
import { antdTheme } from './antdTheme';

interface AntdProviderProps {
  children: React.ReactNode;
}

export function AntdProvider({ children }: AntdProviderProps) {
  const [locale] = useState<Locale>(enGB);

  return (
    <ConfigProvider locale={locale} theme={antdTheme}>
      <AntdApp className={'h-full'}>{children}</AntdApp>
    </ConfigProvider>
  );
}
